import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * Claims, vendors, months and contracts live at readable addresses (/vendors/snowflake). A page
 * opened by an older id link moves itself to its slug once it knows it, keeping the tab.
 */
export function useCanonical(base: string, ref: string | undefined, slug: string | undefined) {
  const nav = useNavigate();
  const loc = useLocation();
  useEffect(() => {
    if (ref && slug && ref !== slug)
      nav(`${base}/${encodeURIComponent(slug)}${loc.search}${loc.hash}`, { replace: true });
  }, [base, ref, slug, nav, loc.search, loc.hash]);
}

/** The address part for a row: its slug when the API sent one, else its id. */
export const ref = (x: { id: string; slug?: string | null }) => x.slug ?? x.id;
/** The address part for a row's vendor. */
export const vendorRef = (x: { vendor_id?: string | null; vendor_slug?: string | null }) =>
  x.vendor_slug ?? x.vendor_id ?? "";
